import { convertUTCDateToLocalDateString } from "../../helpers/dateHelper";
import { FirmwareInfo } from "../../models/firmware";

interface Props {
  firmwareInfo: FirmwareInfo | null;
}

const UploadedFirmwareInfo: React.FC<Props> = ({ firmwareInfo }) => {
  return (
    <>
      {!firmwareInfo && <></>}
      {firmwareInfo && (
        <>
          <div className="p-1 grid grid-cols-[20%_75%] gap-x-4 gap-y-3">
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-textsecondary">
              Series
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-right overflow-hidden whitespace-normal break-all">
              {firmwareInfo?.series ?? "???"}
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-textsecondary">
              ECU
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-right overflow-hidden whitespace-normal break-all">
              {firmwareInfo?.ecu ?? "???"}
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-textsecondary">
              Engine
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-right overflow-hidden whitespace-normal break-all">
              {firmwareInfo?.engine ?? "???"}
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-textsecondary">
              Software
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-right overflow-hidden whitespace-normal break-all">
              {firmwareInfo?.software ?? "???"}
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-textsecondary">
              Uploaded
            </p>
            <p className="md:text-sm xl:text-lg max-xl:text-lg text-right">
              {convertUTCDateToLocalDateString(firmwareInfo?.uploaded)}
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default UploadedFirmwareInfo;
